import { Stack } from '@mui/material';
import { Partner } from '@provision/entity-types';
import { EditorEvents } from '@provision/rich-text-editor';
import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { RichTextField } from 'src/components/Forms/RichTextField/rich-text-field';
import { NullableDeepPartial } from 'src/graphql/types';

interface RecentAnnouncementsTabProps {
  partner: NullableDeepPartial<Pick<Partner, 'partnerId' | 'partnerOnesheet'>>;
  onFieldChange: (field: string, value: string) => void;
  readonly: boolean;
}

export const RecentAnnouncementsTab = ({
  partner,
  onFieldChange,
  readonly,
}: RecentAnnouncementsTabProps) => {
  const partnerDetails = partner?.partnerOnesheet?.[0];

  const fields = useMemo(() => {
    if (isNullish(partner?.partnerId)) {
      return [];
    }

    return [
      {
        label: 'Recent Announcements',
        editorOptions: {
          editable: !readonly,
          onUpdate: ({ editor }: EditorEvents['update']) => {
            onFieldChange('recentAnnouncements', editor.getHTML());
          },
          content: partnerDetails?.recentAnnouncements ?? '',
        },
        dependencies: [partner.partnerId],
      },
    ];
  }, [readonly, partner.partnerId, partnerDetails?.recentAnnouncements, onFieldChange]);

  return (
    <Stack spacing={2} sx={{ paddingTop: 2 }}>
      {fields.map((field) => (
        <RichTextField
          key={field.label}
          label={field.label}
          editorOptions={field.editorOptions}
          dependencies={field.dependencies}
        />
      ))}
    </Stack>
  );
};
